var impressum = "版权声明";
var privacy = "隐私和法律";
var recallInfo = "召回信息";
var signOut = "退出登录";
var zh_cn = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { zh_cn as default, impressum, privacy, recallInfo, signOut };
